module.exports = __webpack_public_path__ + "static/media/unboxing_summer_4.f903942e.jpg";